export default __webpack_public_path__ + "static/media/nfcfx.b0c11522.mp3";